import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import VueGtag from "vue-gtag"
Vue.use(VueGtag, {
  config: { id: "UA-129082745-2" }
})

Vue.config.productionTip = false

import Firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'
var config = {
  apiKey: "AIzaSyBU1qVlXfEhoXZygM9pJ8QR7VddwT3Uvhc",
  authDomain: "diginomix-a3b34.firebaseapp.com",
  databaseURL: "https://diginomix-a3b34.firebaseio.com",
  projectId: "diginomix-a3b34",
  storageBucket: "diginomix-a3b34.appspot.com",
  messagingSenderId: "70153642438"
}

Firebase.initializeApp( config )
export const db = Firebase.firestore()
export const auth = Firebase.auth()
export const str = Firebase.storage()

import VueFirestore from 'vue-firestore'
Vue.use( VueFirestore, { key: 'id' } )

import VueMeta from 'vue-meta'
Vue.use( VueMeta, {
  keyName: 'meta'
})

import VueSuglify from "vue-suglify"
Vue.component("suglify", VueSuglify)

import VueAgile from 'vue-agile'
Vue.use(VueAgile)

import VueMasonry from 'vue-masonry-css'
Vue.use( VueMasonry )

import VerticalTimeline from 'vue-vertical-timeline'
Vue.use( VerticalTimeline )

import DigiFlex from '@/components/digi-flex'
Vue.component('digi-flex', DigiFlex)

import DigiGrid from '@/components/digi-grid'
Vue.component('digi-grid', DigiGrid)

import DigiButton from '@/components/digi-button'
Vue.component('digi-button', DigiButton)

import DigiWrapper from '@/components/digi-wrapper'
Vue.component('digi-wrapper', DigiWrapper)

import DigiDivider from '@/components/digi-divider'
Vue.component('digi-divider', DigiDivider)

import DigiInput from '@/components/digi-input'
Vue.component('digi-input', DigiInput)

// import DigiLanding from '@/components/digi-landing'
// Vue.component('digi-landing', DigiLanding)

import BaseCard from '@/components/base-card'
Vue.component('base-card', BaseCard)

import "vue-material-design-icons/styles.css"
import HomeIcon from "vue-material-design-icons/HomeOutline.vue"

import LogoIcon from 'vue-material-design-icons/AngleRight'
Vue.component('logo-icon', LogoIcon)

import LocationIcon from 'vue-material-design-icons/MapMarker'
Vue.component('location-icon', LocationIcon)

import SendIcon from "vue-material-design-icons/Send.vue"
Vue.component('send-icon', SendIcon)

import EmailIcon from "vue-material-design-icons/EmailVariant.vue"
Vue.component('email-icon', EmailIcon)

import CloseIcon from "vue-material-design-icons/CloseBox.vue"
Vue.component('close-icon', CloseIcon)

import LeftIcon from 'vue-material-design-icons/MenuLeft.vue'
Vue.component('left-icon', LeftIcon)

import RightIcon from 'vue-material-design-icons/MenuRight.vue'
Vue.component('right-icon', RightIcon)

import EmailPlusOutlineIcon from "vue-material-design-icons/EmailPlusOutline.vue"
import InformationOutlineIcon from "vue-material-design-icons/InformationOutline.vue"

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
